import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {BrowserRouter} from 'react-router';
import posthog from 'posthog-js'

// Proza Libre, self-hosted (SIL OFL). It used to arrive from fonts.googleapis.com, which
// sends every visitor's IP to Google before the consent banner has asked anything.
// latin-ext carries the diacritics in Länder and speaker names that latin alone misses.
import '@fontsource/proza-libre/latin-400.css';
import '@fontsource/proza-libre/latin-600.css';
import '@fontsource/proza-libre/latin-700.css';
import '@fontsource/proza-libre/latin-400-italic.css';
import '@fontsource/proza-libre/latin-ext-400.css';
import '@fontsource/proza-libre/latin-ext-600.css';
import '@fontsource/proza-libre/latin-ext-700.css';

// The design system. ☠️ `css/index.css` sat below these until the cutover — the previous
// implementation's global sheet, kept so its pages would still win. ⚠️ It was **not** purely
// legacy by the end: the header rebuilt on 2026-09-06 lived in it, so deleting the file as
// planned took the live masthead with it. What is still load-bearing moved to `shell.css`.
import './styles/tokens.css';
import './styles/typography.css';
import './styles/global.css';
import './styles/shell.css';

import Router from './Router';

if (!location.origin.includes('localhost')) {
    posthog.init('phc_6oi0Ovcrzcmp2jwzc80EZMtFtgTJyikKCXpEVqZRHbq', {
        api_host: 'https://eu.i.posthog.com',
        defaults: '2025-11-30',
        persistence: 'localStorage',
        opt_out_capturing_by_default: true, // Start disabled, enable after consent
    });
}

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrowserRouter>
            <Router/>
        </BrowserRouter>
    </StrictMode>,
)
